import { render, staticRenderFns } from "./userAuth.vue?vue&type=template&id=c069b9a4&"
import script from "./userAuth.vue?vue&type=script&lang=js&"
export * from "./userAuth.vue?vue&type=script&lang=js&"
import style0 from "./userAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports